module.exports = __webpack_public_path__ + "img/computer-3716291_1920.160c051d.jpg";